"use client";

import { Category, FAQ_CATEGORIES } from "@/sanity/lib/types";
import posthog from "posthog-js";

interface FaqsCategoriesProps {
  openedCategory: Category | null;
  setOpenedCategory: React.Dispatch<React.SetStateAction<Category>>;
}

export default function FaqsCategories({
  openedCategory,
  setOpenedCategory,
}: FaqsCategoriesProps) {
  return (
    <nav className="mt-4 min-w-83">
      <ul className="flex flex-col gap-10">
        {FAQ_CATEGORIES.map((category, i) => (
          <li key={i}>
            <button
              className={`${openedCategory === category ? "text-accent" : "text-primary"} hover:text-accent bg-transparent uppercase md:text-5xl`}
              onClick={() => {
                setOpenedCategory(category);
                posthog.capture("faq_category_selected", { category });
              }}
            >
              <h2>{category}</h2>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
